module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "signup-header row border-bottom-light row justify-content-sm-center"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h5', {
    staticClass: "color-6"
  }, [_vm._v("2. Details")]), _vm._v(" "), _c('h2', [_vm._v("Can you tell us more about " + _vm._s(_vm.brand) + ".")]), _vm._v(" "), _c('h4', [_vm._v("Just the usual stuff.")])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-sm-center"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('form', {
    staticClass: "shaded",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.processForm($event)
      }
    }
  }, [(_vm.sizes) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Company size")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "placeholder": "How many employees do you have?",
      "options": _vm.sizes,
      "label": "description",
      "searchable": false
    },
    on: {
      "input": _vm.updateSize
    },
    model: {
      value: (_vm.selectedSize),
      callback: function($$v) {
        _vm.selectedSize = $$v
      },
      expression: "selectedSize"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-sm-6",
    class: {
      error: _vm.$v.form.companyEmail.$error
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                            Email (for customer contact)\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.companyEmail),
      expression: "form.companyEmail",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "email",
      "placeholder": "Please add your email"
    },
    domProps: {
      "value": (_vm.form.companyEmail)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "companyEmail", $event.target.value.trim())
      }, _vm.$v.form.companyEmail.$touch],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.companyEmail.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.form.companyEmail.required) ? _c('span', [_vm._v("Email is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.companyEmail.email) ? _c('span', [_vm._v("Must be a valid email")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    class: {
      error: _vm.$v.form.companyPhone.$error
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                            Phone (for customer contact)\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.companyPhone),
      expression: "form.companyPhone"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "Please add your phone no."
    },
    domProps: {
      "value": (_vm.form.companyPhone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "companyPhone", $event.target.value)
      }, _vm.$v.form.companyPhone.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.form.companyPhone.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.form.companyPhone.required) ? _c('span', [_vm._v("Business phone is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.companyPhone.numeric) ? _c('span', [_vm._v("Must be a phone number.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.companyPhone.minLength) ? _c('span', [_vm._v("Business phone must have at least 9 numbers.")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('location-fields', {
    on: {
      "locationFieldsChanged": _vm.updateLocationFields
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "full mb-4"
  }, [_vm._v("Your sales channels")]), _vm._v(" "), _c('label', {
    staticClass: "full mb-2"
  }, [_c('checkbox', {
    model: {
      value: (_vm.form.salesStore),
      callback: function($$v) {
        _vm.$set(_vm.form, "salesStore", $$v)
      },
      expression: "form.salesStore"
    }
  }, [_vm._v("\n                            I'm selling in my own store\n                        ")])], 1), _vm._v(" "), _c('label', {
    staticClass: "full mb-2"
  }, [_c('checkbox', {
    model: {
      value: (_vm.form.salesWebsite),
      callback: function($$v) {
        _vm.$set(_vm.form, "salesWebsite", $$v)
      },
      expression: "form.salesWebsite"
    }
  }, [_vm._v("\n                            I'm selling in my website\n                        ")])], 1), _vm._v(" "), _c('label', {
    staticClass: "full mb-2"
  }, [_c('checkbox', {
    model: {
      value: (_vm.form.salesOtherAgents),
      callback: function($$v) {
        _vm.$set(_vm.form, "salesOtherAgents", $$v)
      },
      expression: "form.salesOtherAgents"
    }
  }, [_vm._v("\n                            I have other agents selling my services.\n                        ")])], 1), _vm._v(" "), _c('label', {
    staticClass: "full mb-2"
  }, [_c('checkbox', {
    model: {
      value: (_vm.form.salesOtherWebsites),
      callback: function($$v) {
        _vm.$set(_vm.form, "salesOtherWebsites", $$v)
      },
      expression: "form.salesOtherWebsites"
    }
  }, [_vm._v("\n                            I'm selling in others websites.\n                        ")])], 1), _vm._v(" "), _c('label', {
    staticClass: "full mb-2"
  }, [_c('checkbox', {
    model: {
      value: (_vm.form.salesNone),
      callback: function($$v) {
        _vm.$set(_vm.form, "salesNone", $$v)
      },
      expression: "form.salesNone"
    }
  }, [_vm._v("\n                            I'm starting and have no sales yet.\n                        ")])], 1), _vm._v(" "), _c('label', {
    staticClass: "full mb-2"
  }, [_c('checkbox', {
    model: {
      value: (_vm.form.salesOther),
      callback: function($$v) {
        _vm.$set(_vm.form, "salesOther", $$v)
      },
      expression: "form.salesOther"
    }
  }, [_vm._v("\n                            Other\n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'auth.signup.supplier.create'
      }
    }
  }, [_c('input', {
    staticClass: "btn tertiary widest full",
    attrs: {
      "type": "button",
      "value": "Back"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    staticClass: "btn action widest full",
    class: {
      'opacity-50': _vm.submittingRegistration
    },
    attrs: {
      "type": "submit",
      "value": "Finish",
      "disabled": !_vm.$v.form.$dirty || _vm.$v.form.$error
    }
  })])])], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-574e6c02", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-574e6c02"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/supplier/Step3.vue
// module id = 1635
// module chunks = 0